// extracted by mini-css-extract-plugin
module.exports = {"formBody":"ContentUpdatePage_formBody__2FcJd","backButton":"ContentUpdatePage_backButton__3AuKm","optionalCheckBox":"ContentUpdatePage_optionalCheckBox___z3HY"};